import React from 'react'
export default function HowToOrder(){
    

    return <div className='howToOrder'>
                     <p style={{textAlign:'center',alignSelf:'center'}}>Oбувь Украинского производителя  KUVA оптом</p>
     
                <div className='roundImg'></div>
                    <p style={{textAlign:'center'}}>OБУВЬ  на сайте продается только оптом.</p>
        <li>Заказ можно оформить по телефону : 0503236672 </li>
        <li>Viber    : 0503236672</li>
        <li>Telegram : 0503236673</li>
        <li>WhatsApp : 0503236672</li>
        <li>    Oтправив письмо на электронный адрес kuva68@gmail.com</li>
        <li> Заполнив форму заказа на сайте.
        </li></div>
    
}